<template>
    <van-dialog v-model:show="visible" title="请选择后续操作" show-cancel-button confirm-button-text="扫码连接望诊仪"
        cancel-button-text="手机采集" :class-name="'large-dialog'" @confirm="handleConfirm" @cancel="handleCancel">
        <div class="dialog-content">
            <div>
                您可以选择继续进行手机端面像采集,
            </div>
            <div>
                或者通过扫码连接望诊仪进行采集。
            </div>
        </div>
    </van-dialog>
</template>

<script>
import { Dialog } from 'vant';

export default {
    name: 'WZYConnectDialog',
    components: {
        [Dialog.Component.name]: Dialog.Component,
    },
    data() {
        return {
            visible: false,
        };
    },
    methods: {
        show() {
            this.visible = true;
        },
        hide() {
            this.visible = false;
        },
        handleConfirm() {
            this.$emit('scan-wzy');
            this.hide();
        },
        handleCancel() {
            this.$emit('mobile-collect');
            this.hide();
        },
    },
};
</script>

<style scoped>
.dialog-content {
    padding: 24px 24px;
    font-size: 16px;
    line-height: 1.8;
    color: #646566;
    text-align: left;
}

.dialog-content>div {
    margin-bottom: 12px;
}

.dialog-content>div:last-child {
    margin-bottom: 0;
}

.large-dialog {
    max-width: 85%;
}
</style>
